import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '../views/Home.vue'
import AstrolabeView from '../views/AstrolabeView'
import tianxingRoutes from '../features/tianxing/router'
import adminRoutes from '../features/admin/router'
import csRoutes from '../features/customerService/router'

Vue.use(VueRouter)

const routes = [
  // 星盘页由根路径迁移到 /onlineChart（原站同名入口）
  {
    path: '/onlineChart',
    name: 'AstrolabeView',
    component: AstrolabeView
  },
  // 根路径改为跳转天星首页
  {
    path: '/',
    redirect: '/tianxing/home'
  },
  ...tianxingRoutes,
  ...adminRoutes,
  ...csRoutes
]

// 使用 history 模式：直接访问 /tianxing/home 这类深路由时由 nginx try_files 兜底到 index.html。
// 若用默认 hash 模式，/tianxing 会因 hash 为空而落到 '/'（现已是跳转首页），且地址栏带 #。
const router = new VueRouter({
  mode: 'history',
  routes
})

// 登录守卫：仅对 /admin/*（管理后台）与 /cs/*（客服工作台）生效，
// 两者使用各自独立的 token（admin_jwt / cs_jwt），互不干扰，
// 也不影响星盘与天星其他路由。
router.beforeEach((to, from, next) => {
  if (!to.meta.public && to.path.startsWith('/admin')) {
    const token = localStorage.getItem('admin_jwt')
    if (!token) {
      return next({ path: '/admin/login', query: { redirect: to.fullPath } })
    }
  }
  if (!to.meta.public && to.path.startsWith('/cs')) {
    const token = localStorage.getItem('cs_jwt')
    if (!token) {
      return next({ path: '/cs/login', query: { redirect: to.fullPath } })
    }
  }
  next()
})

export default router
